<template>
    <div>
        <label
            class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
        >
            Show entries
        </label>
        <div class="flex items-center space-x-2">
            <select
                :value="modelValue"
                @change="
                    $emit(
                        'update:modelValue',
                        Number(($event.target as HTMLSelectElement).value),
                    )
                "
                class="w-24 px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
            >
                <option v-for="option in options" :key="option" :value="option">
                    {{ option }}
                </option>
            </select>
        </div>
    </div>
</template>

<script setup lang="ts">
withDefaults(
    defineProps<{
        modelValue: number;
        options?: number[];
    }>(),
    {
        options: () => [10, 50, 100, 250, 500, 1000],
    },
);

defineEmits<{
    "update:modelValue": [value: number];
}>();
</script>
